<template>
  <div class="wrapper" :class="[{'vowel-bg': lesson.category === 'vowel'}]">
    <el-tooltip
      class="item"
      :open-delay="500"
      effect="dark"
      content="このレッスンのアクセスにはプレミアムプランのご契約が必要です"
      placement="top"
    >
      <div class="lock" v-show="lock">
        <div class="lock-overlay"></div>
        <img src="@/assets/lock.svg" alt="locked" />
      </div>
    </el-tooltip>
    <div
      class="category"
      :style="`background-color:${lesson.category === 'vowel' ? '#f88': '#555'};
               color:${lesson.category === 'vowel' ? 'white': 'white'}`"
    >{{lesson.category === 'vowel' ? '母音':'子音'}}</div>
    <div class="type">{{lesson.type}}</div>

    <div class="example">{{lesson.example}}の</div>

    <div class="target-phoneme">{{lesson.titlePhoneme}}</div>
    <div
      v-show="!lock"
      @click="goToLesson(lesson)"
      class="lesson-nav-btn"
      :class="[{'vowel': lesson.category === 'vowel'},{'consonant': lesson.category === 'consonant'}]"
    >/{{lesson.targetPhoneme}}/のレッスンへ</div>

    <ProgressCircle class="progress" :percentage="Math.ceil(achieved)" />
  </div>
</template>

<script>
const workbooks = require("@/resources/workbooks");
import problemResultRepo from "@/utils/ProblemResultRepository";
import { CLEAR_SCORE } from "@/constants";

export default {
  components: {
    ProgressCircle: require("@/components/ProgressCircle").default
  },
  props: ["lesson", "lock", "cleared"],
  data() {
    return {
      achieved: 0,
      total: 0,
      negativeMargins: {
        b: "-18px"
      },
      problemResults: {}
    };
  },
  methods: {
    goToLesson(lesson) {
      console.log(lesson);
      this.$router.push({
        path: "lesson",
        query: { category: lesson.titlePhoneme }
      });
    },
    loadAchievement() {
      return 0;
    }
  },
  mounted() {
    let self = this;
    let clearedNumber = 0;
    // problemResultRepo
    //   .getResults()
    //   .then(results => {
    //     const cleared = results.filter(result => {
    //       return (
    //         result.phoneme === this.lesson.targetPhoneme && result.score >= 80
    //       );
    //     }).length;

    //     const currentWorkbooks = workbooks.filter(workbook => {
    //       return workbook.targetPhoneme === this.lesson.targetPhoneme;
    //     });
    //     let total = 0;
    //     currentWorkbooks.forEach(cw => {
    //       cw.problems.forEach(pr => {
    //         total++;
    //       });
    //     });

    //     self.achieved = (cleared / total) * 100;
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   });
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 200px;
  height: 200px;
  position: relative;
  margin: 10px;
  padding: 10px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  border-radius: 5px;
  background-color: #fafafa;
  overflow: hidden;
  &:hover {
    @include dark-shadow;
    /* transform: scale(1.15); */
    z-index: 100;
    .lesson-nav-btn {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .category {
    display: inline-block;
    padding: 2px 13px;
    font-size: 1.1rem;
    font-weight: bold;
    border-radius: 20px;
  }

  .example {
    text-align: center;
    margin-top: 12px;
    font-weight: bold;
    font-size: 1.1rem;
  }

  .target-phoneme {
    font-size: 4rem;
    font-weight: bold;
    user-select: none;
    margin-top: -20px;
    text-align: center;
  }

  .lesson-nav-btn {
    opacity: 0;
    transition: transform 0.3s ease;
    /* transition-delay: 0.2s; */
    transform: translateX(30px);
    font-size: 0.8rem;
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    right: 0;
    border: 0;
    color: white;
    padding: 8px 8px 8px 13px;
    margin: auto;
    border-radius: 20px 0 0 20px;
    font-weight: bold;
    z-index: 100;
  }

  .consonant {
    background-color: #555;
    &:hover {
      background-color: #444;
    }
  }

  .vowel {
    background-color: #f88;
    &:hover {
      background-color: #f77;
    }
  }

  .progress {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 1;
  }
  .lock {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    .lock-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.8);
      z-index: 10;
    }
    img {
      width: 32px;
      padding: 12px;
      background-color: white;
      border-radius: 50%;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.13);
      z-index: 11;
    }
  }

  .type {
    position: absolute;
    right: 20px;
    top: 14px;
    font-size: 0.9rem;
    color: #aaa;
  }
}

.vowel-bg {
  background-color: #ffefef;
}

/* .wrapper {
  width: 200px;
  height: 200px;
  position: relative;
  margin: 10px;
  box-sizing: border-box;
  z-index: 10;
} */
/* .vowel {
  background-color: #ffefef !important;
}

.lock {
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: not-allowed;
  z-index: 1;
  .lock-overlay {
    background-color: rgba(255, 255, 255, 1);
    z-index: 1;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 40px;
    z-index: 1001;
    padding: 15px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.13);
  }
}

.category_vowel {
  background-color: #f88 !important;
}

.category {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 64px;
  height: 32px;
  border-radius: 20px;
  background-color: #555;
  span {
    @include centerer;
    color: white;
  }
}

.example {
  margin-top: 55px;
  font-size: 1.3rem;
}
.target-phoneme {
  margin-top: -18px;
  font-size: 3.8rem;
  font-weight: bold;
  user-select: none;
} */
/* button {
  opacity: 0;
  transition: all 0.3s ease;
  transition-delay: 0.1s;
  transform: translateX(30px);
  cursor: pointer;
  position: absolute;
  bottom: 12px;
  right: 0;
  border: 0;
  background-color: #666;
  color: white;
  padding: 10px 10px 10px 20px;
  margin: auto;
  border-radius: 5px 0 0 5px;
  font-weight: bold;
}
.wrapper {
  border-radius: 5px;
  font-weight: bold;
  overflow: hidden;
  text-align: center;
  position: relative;
  width: 200px;
  height: 200px;
  margin: 10px;
  box-sizing: border-box;
  z-index: 10;
  display: inline-block;
  box-shadow: none;
  background-color: #00000008;
  transition: all 0.3s ease;
  img {
    opacity: 0;
    position: absolute;
    right: -16px;
    top: -16px;
    transform: rotate(-90deg) scale(1) translate3d(20px, 20px, 0);
    transition: all 0.3s ease;
    transition-delay: 0.3s;
    svg {
      path {
        fill: white;
      }
    }
  } */

/* .description {
    display: none;
    position: absolute;
    top: 150px;
    font-size: 0.8rem;
    color: #555;
    line-height: 1rem;
    margin: 0 4px;
  }
  &:hover,
  &:active,
  &:focus {
    button {
      opacity: 1;
      transform: translateX(0);
    }
    box-shadow: 0 28px 50px rgba(25, 24, 40, 0.35);
    border-radius: 0;

    img {
      opacity: 1;
      transform: scale(1) rotate(-90deg) translate3d(0, 0, 0);
    }

    transform: scale(1.15);
    z-index: 10;

    .description {
      display: block;
    }
  }
} */

/* .phoneme-type-container {
  text-align: center;
  margin: 20px 0;
  .active {
    background-color: #555;
    color: white;
  }
}

.achieved-container {
  left: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: #eee;
  .achieved {
    background-color: #f88;
    height: 100%;
    width: 0;
    transition: all 1s ease;
  }
}

.button {
  margin: 10px 0;
}

.progress {
  position: absolute;
  bottom: 5px;
  left: 15px;
  &::after {
    content: "進捗度";
    font-size: 0.7rem;
    color: #888;
  }
}

.slash {
  color: rgba(0, 0, 0, 0.03);
  display: inline;
}

.type {
  position: absolute;
  right: 20px;
  top: 21px;
  font-size: 0.9rem;
  color: #aaa;
} */
</style>
